import DashboardHeader from "@/components/DashboardHeader";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { GET } from "@/services/api";
import { useAppSelector } from "@/hooks/hook";
import { API_ROUTES } from "@/services/environment";
import { useSearchParams } from "react-router-dom";
import EventsTable from "./components/EventsTable";
import { Booking } from "./Interface";
import { EventDetailPage } from "./EventDetailPage";
import { IoMdArrowBack } from "react-icons/io";
import { format, parseISO } from "date-fns";
import { toZonedTime } from "date-fns-tz";
import clockIcon from "../../assets/icons/clockIcon.svg";
import userIcon from "../../assets/icons/userIcon.svg";
import { RiCircleFill } from "react-icons/ri";
import useLoading from "@/hooks/useLoading";
import { getTimeDifference, Loader,  USFormatePriceWithoutDecimal } from "@thdinc/hpf-shared";
import { timeToAmPm } from "@/helpers/TimeFormat";
interface User {
  first_name: string;
  last_name: string;
  roles: string;
  // Add other properties of the user object if available
}

const EventsPage = () => {
  // const params = useParams();
  const location = useLocation();
  localStorage.removeItem("eventId");
  const { isLoading, startLoading, stopLoading } = useLoading();

  useEffect(() => {
    if (location.state?.url) {
      if (location.state.url.split("/")[2]) {
        setBookingId(location.state.url.split("/")[2]);
      } else {
        setBookingId(location.state.url);
      }
      setDetailView(true);
    }
  }, [location.state]);

  const { getPastEventApi, getUpcomingEventApi } = API_ROUTES;
  const [currentQueryParameters, setSearchParams] = useSearchParams();
  const newQueryParameters: URLSearchParams = new URLSearchParams();
  const { refreshToken } = useAppSelector((store) => store.user);

  const navigate = useNavigate();
  const [currTab, setCurTab] = useState("");
  const [pastEvents, setPastEvents] = useState<Booking[]>([]);
  const [upComingEvent, setUpComingEvent] = useState<Booking[]>([]);
  const [rerender, setRerender] = useState<boolean>(false);
  const [detailView, setDetailView] = useState(false);
  const [bookingId, setBookingId] = useState<string>("");
  useEffect(() => {
    if (currTab === "Past") {
      const getPastEvents = async () => {
        try {
          const result = await GET(`${getPastEventApi}`, refreshToken);
          setPastEvents(result?.data);
        } catch (err) {
          console.log(String(err));
        } finally {
          stopLoading();
        }
      };
      getPastEvents();
    }
    if (currTab === "Upcoming") {
      const getUpcoming = async () => {
        try {
          startLoading();
          const result = await GET(`${getUpcomingEventApi}`, refreshToken);
          setUpComingEvent(result?.data);
        } catch (err) {
          console.log(String(err));
        } finally {
          stopLoading();
        }
      };
      getUpcoming();
    }
  }, [currTab, rerender]);

  // update tab also close open forms state (Package and cocktails)
  const updateTab = (name: string) => {
    setCurTab(name);
    setBookingId("");
    setDetailView(false);
    newQueryParameters.set("tab", "dw");
    navigate(`?tab=${name}`);
  };
  // set tab on initial render
  useEffect(() => {
    setCurTab(currentQueryParameters.get("tab") || "business");
    if (currentQueryParameters.get("id")) {
      const id = currentQueryParameters.get("id");
      setBookingId(id as string);
      setDetailView(true);
    }
  }, []);
  const openDetailView = (bookingId: string) => {
    setDetailView(true);
    setBookingId(bookingId);
  };

  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  const fitleredUpcoming = upComingEvent.filter((item: Booking) => {
    const { start_time } = item;
    const date = format(parseISO(start_time), "PPPP");
    const adminName = `${item.first_name} ${item.last_name}`.toLowerCase();
    const search = searchQuery.toLowerCase();
    return (
      date.toLocaleLowerCase().includes(search) || adminName.includes(search)
    );
  });

  const filteredPastEvents = pastEvents.filter((item: Booking) => {
    const { start_time } = item;
    const date = format(parseISO(start_time), "PPPP");
    // let price = 0;
    // if (discount_total !== 0) {
    //   price = roundUpPrice(
    //     producttotal / 100 - discount_total / 100 + service_total / 100
    //   );
    // } else {
    //   price = roundUpPrice(producttotal / 100 + service_total / 100);
    // }

    const adminName = `${item.first_name} ${item.last_name}`.toLowerCase();
    const search = searchQuery.toLowerCase();
    return (
      date.toLocaleLowerCase().includes(search) || adminName.includes(search)
    );
  });
  return (
    <div>
      <div className="flex items-start md:items-center gap-1 flex-wrap justify-between mt-2 sticky top-[64px] bg-p-gray z-30">
        <div className="flex gap-3 items-center cursor-pointer w-full">
          {detailView && (
            <div
              onClick={() => setDetailView(false)}
              className="bg-white p-2 mt-4 md:mt-2 rounded-full"
            >
              <IoMdArrowBack />
            </div>
          )}
          <DashboardHeader width="w-full" title="Bookings">
            <div className="flex items-center gap-3 flex-wrap md:flex-nowrap mt-2 md:mt-0 ">
              {!detailView && (
                <input
                  type="text"
                  placeholder="Search Client Name or Date"
                  onChange={handleSearch}
                  className="w-full md:min-w-64 px-4 py-3  rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                  name=""
                  id=""
                />
              )}
              {/* Tabs  */}
              {!detailView && (
                <ul className="  flex   font-medium text-center text-gray-500  border-gray-400  bg-white rounded-full w-fit p-1 mb-2 md:mb-0">
                  <button
                    onClick={() => updateTab("Past")}
                    aria-current="page"
                    className={`inline-block px-5 py-2      ${
                      currTab === "Past"
                        ? "text-white   bg-black rounded-full "
                        : ""
                    }`}
                  >
                    Past
                  </button>
                  <li className="me-2 cursor-pointer">
                    <div
                      onClick={() => updateTab("Upcoming")}
                      className={`inline-block px-5 py-2 ${
                        currTab === "Upcoming"
                          ? "text-white   bg-black rounded-full "
                          : ""
                      } `}
                    >
                      Upcoming
                    </div>
                  </li>
                </ul>
              )}
            </div>
          </DashboardHeader>

          {/* {bookingId === "" ? (
            <div
              className="flex  items-center"
              onClick={() => updateTab(currTab)}
            >
              <MdOutlineKeyboardDoubleArrowRight className="text-primary-red" />
              <p className="underline hover:cursor-pointer text-primary-red ">
                {currTab}
              </p>
            </div>
          ) : (
            <div className="flex  items-center">
              <MdOutlineKeyboardDoubleArrowRight className="text-primary-red" />
              <p
                onClick={() => updateTab(currTab)}
                className="underline hover:cursor-pointer text-primary-red "
              >
                {currTab}
              </p>
              <MdOutlineKeyboardDoubleArrowRight className="text-primary-red" />
              <p className="underline hover:cursor-pointer text-primary-red translate-x-0">
                {bookingId}
              </p>
            </div>
          )} */}
        </div>
      </div>

      {currTab === "Past" && !detailView && (
        <>
          { filteredPastEvents.length > 0 && (
            <EventsTable
              pastEvents={filteredPastEvents}
              isPast={true}
              openDetailView={openDetailView}
            />
          )}
        </>
      )}
      { !isLoading && !detailView ? (
        fitleredUpcoming.length > 0 ? (
          <div className="grid grid-col-1 md:grid-cols-2 lg:grid-cols-3 transition-all  gap-4 md:gap-6 lg:gap-8">
            {
              currTab === "Upcoming" &&
                !detailView &&
                fitleredUpcoming.map((data, i) => {
                  return (
                    <div
                      key={i}
                      className="cursor-pointer"
                      onClick={() => openDetailView(data.id)}
                    >
                      <EventCards data={data} />
                    </div>
                  );
                })
              // <EventsTable
              //   pastEvents={upComingEvent}
              //   openDetailView={openDetailView}
              // />
            }
          </div>
        ) : currTab !=='Past' ?
           <p className="text-center text-gray-500 text-lg">No Booking</p>
        :''
      ) : !detailView ? (
        <Loader color="bg-red-500" />
      ) : (
        ""
      )}
      {/* Shoe Event Detail Page */}
      {detailView && (
        <EventDetailPage
          bookingId={bookingId}
          rerender={rerender}
          setRerender={setRerender}
        />
      )}
    </div>
  );
};

export default EventsPage;

const EventCards = ({ data }: { data: Booking }) => {
 const user = useAppSelector((store)=> store.user)
  const {
    auto_selected,
    first_name,
    last_name,
    discount_total,
    producttotal,
    service_total,
    start_time,
    end_time,
    timezone,
    guests,
    bartenders,
    btc_name,
    packagetype
  } = data;

  return (
    <div className="p-3 rounded-xl bg-white">
      <div className="flex justify-between items-center">
        <h2 className="text-lg font-semibold">
          {/* {EVENT_TYPE_DATA &&
            EVENT_TYPE_DATA.find((a: any) => a.value === eventtype)?.name} */}
          {first_name + " " + last_name}
        </h2>
        <p className={` text-3xl text-primary-red font-bold`}>
          $
          {discount_total !== 0
            ? USFormatePriceWithoutDecimal(
                roundUpPrice(
                  producttotal / 100 -
                    discount_total / 100 +
                    service_total / 100
                )
              )
            : USFormatePriceWithoutDecimal(
                roundUpPrice(producttotal / 100 + service_total / 100)
              )}{" "}
        </p>
      </div>
      <div>
      {user.roles && <h2 className="text-lg font">{'BTC: ' + btc_name}</h2>}
      </div>
      <div className="flex gap-2">

      {auto_selected ? (
        <p className="text-[#FF6100] text-[10px] font-bold flex items-center gap-1 my-1">
          <RiCircleFill />
          Unassigned
        </p>
      ) : (
        <p className="text-[#00B69B] text-[10px] font-bold flex items-center gap-1 my-1">
          <RiCircleFill />
          Assigned
        </p>
      )}
        {packagetype ==='custom_package' && (
        <p className="text-gray-400 text-[10px] font-bold flex items-center gap-1 my-1">
         
          Custom Package
        </p>
      ) }
       {packagetype ==='standard' && (
        <p className="text-gray-400 text-[10px] font-bold flex items-center gap-1 my-1">
         
          Standard
        </p>
      ) }
      </div>

      <p className=" text-gray-500">
        {" "}
        {start_time && format(parseISO(start_time), "PPPP")}
      </p>
      <p className="text-primary-red text-xs font-semibold ">
        {timeToAmPm(start_time, timezone) +
          " To " +
          timeToAmPm(end_time, timezone)}
      </p>
      <div className="flex justify-between  flex-wrap gap-2 items-baseline mt-5 ">
        <div className="flex items-center justify-start gap-5 ">
          <div className="bg-p-gray px-4 py-1 flex gap-2 items-center rounded-full">
            {/* <BsClock size={14} /> */}
            <img src={clockIcon} />
            <p className="text-sm font-semibold">
              {
                getTimeDifference(
                  format(toZonedTime(start_time, timezone), "HH:mm"),
                  format(toZonedTime(end_time, timezone), "HH:mm")
                ).hours
              }{" "}
              <span className="text-xs">hrs</span>{" "}
            </p>
          </div>
          <div className="bg-p-gray px-4 py-1 flex gap-2 items-center rounded-full">
            {/* <LiaUser size={17} /> */}
            <img src={userIcon} />
            <p className="text-sm font-semibold">{guests}</p>
          </div>
        </div>
        <div className="relaive flex px-2">
          {bartenders.length > 1 ? (
            bartenders.map((br, index) => {
              return (
                <img
                  key={index}
                  className="rounded-full object-cover w-8 h-8 -ml-3 border-2"
                  src={br.avatar}
                />
              );
            })
          ) : (
            <img
              className="rounded-full object-cover w-8 h-8 "
              src={bartenders[0]?.avatar}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const roundUpPrice = (price: number) => {
  const decimalPlaces = 0;
  const factor = Math.pow(10, decimalPlaces);
  const roundedUp = Math.ceil(price * factor) / factor;
  return roundedUp;
};
